module.exports = __webpack_public_path__ + "static/NodeJS-649e35b7668f82161978117b45a31e52.jpg";